module.exports = __webpack_public_path__ + "static/train-waiting-79a72df8a2d3f1bb6a954dc98b1b6e10.jpg";